// extracted by mini-css-extract-plugin
export var callCard = "_kl-0";
export var callMessageButton = "_kl-1";
export var helpIcon = "_kl-3";
export var helpIconContainer = "_kl-4";
export var verticalDivider = "_kl-2";